window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const STORAGE_KEY = "moretroHiddenCancelledOrders";
  let applying = false;
  let timer = 0;

  function hiddenIds(){
    try { return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]").map(String)); }
    catch(e) { return new Set(); }
  }

  function saveHidden(ids){
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  }

  function selectedOrder(){
    return (MTS.state?.orders || []).find(order => String(order.id) === String(MTS.state?.selectedOrderId));
  }

  function addRemoveButton(){
    const order = selectedOrder();
    const actions = document.querySelector("#mtsShopOrderDetail .mts-project-main-actions");
    if(!actions || !order?.cancelledAt || document.getElementById("mtsRemoveCancelledOrder")) return;

    const button = document.createElement("button");
    button.type = "button";
    button.id = "mtsRemoveCancelledOrder";
    button.className = "mts-btn";
    button.textContent = "🗑️ Retirer du Studio";
    button.addEventListener("click", () => {
      if(!confirm(`Retirer ${order.name || "cette commande annulée"} du Studio ?\n\nLa commande restera disponible dans l'administration Shopify.`)) return;
      const ids = hiddenIds();
      ids.add(String(order.id));
      saveHidden(ids);
      MTS.state.orders = (MTS.state.orders || []).filter(item => String(item.id) !== String(order.id));
      MTS.state.selectedOrderId = "";
      MTS.Orders?.render?.();
    });
    actions.appendChild(button);
  }

  function applyHiddenOrders(){
    if(applying) return;
    applying = true;
    try {
      const ids = hiddenIds();
      const orders = MTS.state?.orders;
      if(Array.isArray(orders) && ids.size){
        const visible = orders.filter(order => !ids.has(String(order.id)));
        if(visible.length !== orders.length){
          MTS.state.orders = visible;
          if(ids.has(String(MTS.state.selectedOrderId))) MTS.state.selectedOrderId = "";
          MTS.Orders?.render?.();
        }
      }
      addRemoveButton();
    } finally {
      applying = false;
    }
  }

  function schedule(){
    clearTimeout(timer);
    timer = setTimeout(applyHiddenOrders, 80);
  }

  function start(){
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
    document.addEventListener("click", event => {
      if(event.target.closest("#mtsRefreshOrders") || event.target.closest('[data-panel="shop"]')){
        setTimeout(applyHiddenOrders, 400);
      }
    });
    setTimeout(applyHiddenOrders, 1700);
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

})(window.MTS);
